// extracted by mini-css-extract-plugin
module.exports = {"root":"📦JQUIListItemLink__root--1iyS5","link":"📦JQUIListItemLink__link--v6Udm","title":"📦JQUIListItemLink__title--2dvIV"};